import React from 'react';
import PhreakDialer from './components/PhreakDialer';

function App() {
  return (
    <div className="App">
      <PhreakDialer />
    </div>
  );
}

export default App;